import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Keywords } from "../enums/kewords.enum";
import { PermissionsCategoriesModel } from "../interfaces/permissionsCategoriesModel";

const TOKEN = "TOKEN";
const UserDetailes = "UserDetailes";

@Injectable({
  providedIn: "root"
})
export class CustomerService {

  constructor(private router: Router) {}

  setToken(token: string): void {
    sessionStorage.setItem(TOKEN, token);
  }
  
  isLogged() {
    return sessionStorage.getItem(TOKEN) != null;
  }

  logout() {
    sessionStorage.removeItem(TOKEN);
    localStorage.removeItem(UserDetailes);
    this.router.navigateByUrl("/login");
  }
  
  setUserPermissions(UserPermissions:string[]) : void {
    console.log(UserPermissions)
    let userPermissions : string [] = [];
    UserPermissions.forEach(prem => {
      //prem.permissions.forEach(element => {
        userPermissions.push(prem);
     // });
    });
    sessionStorage.setItem(Keywords.USER_PERMISSIONS, JSON.stringify(userPermissions));
  }

}
